import { gql } from '@apollo/client';

export default gql`
  mutation createContract(
    $branch: String
    $disabled: Boolean
    $additionId: String
    $name: String
    $nameAr: String
    $desc: String
    $address: String
    $start: Date
    $end: Date
    $locationLink: String
    $status: Int
    $userId: String
    $note: String
  ) {
    createContract(
      branch: $branch
      disabled: $disabled
      additionId: $additionId
      name: $name
      nameAr: $nameAr
      desc: $desc
      address: $address
      start: $start
      end: $end
      locationLink: $locationLink
      status: $status
      userId: $userId
      note: $note
    ) {
      ok
      message
      data
      error
    }
  }
`;
